<div class="page-header" [class.page-header--keep-icon-on-mobile]="keepIconOnMobile">
  <div class="page-header__left">
    <div class="page-header__icon">
      @if (doubleArrows) {
        <span class="sgl-arrows sgl-arrows--lg page-header__arrows" aria-hidden="true"></span>
      } @else {
        <img ngSrc="/icons/sgl_header_arrows_white.png" alt="" height="16" width="30" />
      }
    </div>
    <div class="page-header__text">
      <div class="page-header__breadcrumb">
        <!-- Own element so the whitespace before the arrow is dropped, leaving only its margin. -->
        <span>{{ breadcrumb }}</span>
        @if (breadcrumb === 'Uncomplicate Your World.') {
          <span class="sgl-arrows" aria-hidden="true"></span>
        }
      </div>
      <div class="page-header__title">
        {{ title }}
      </div>
    </div>
  </div>
  <div class="page-header__actions">
    <ng-content></ng-content>
  </div>
</div>
